import React from "react";
import { createPortal } from "react-dom";

import { MainToolbarContext } from "./MainToolbarContext";

interface MainToolbarContentsProps {
    children?: React.ReactNode;
}

class MainToolbarContents extends React.Component<MainToolbarContentsProps> {
    static contextType = MainToolbarContext;
    context!: React.ContextType<typeof MainToolbarContext>;

    render(): React.ReactNode {
        const portal = this.context.ref?.current;

        return portal ? createPortal(this.props.children, portal) : null;
    }
}

export default MainToolbarContents;
